module.exports = __webpack_public_path__ + "catalog/items/bedroom/fancy-bed/fancy-bed.svg";